import { AppState } from "./AppState";
import { ScoreConfig } from "../data/ScoreConfig";

/** Get combo multiplier from combo count */
export function getComboMultiplier(state: AppState): number {
  const table = ScoreConfig.comboMultiplierTable;
  const index = Math.min(state.combo, table.length - 1);
  return table[index];
}

/** Get stage factor */
export function getStageFactor(state: AppState): number {
  return (
    ScoreConfig.stageFactorBase +
    (state.stage - 1) * ScoreConfig.stageFactorIncrement
  );
}

/** Check if player can share on X */
export function canShare(state: AppState): boolean {
  return state.sharesUsed < 1;
}

/** Check if all blocks have been removed (stage clear) */
export function isStageClear(state: AppState): boolean {
  return state.blocksRemaining <= 0;
}
